import domReady from '../helpers/dom-ready';

class UserRole {
  static init() {
    return new UserRole();
  }

  constructor() {
    this.userRoleDialogWrapper = document.querySelector('.user-role-dialog-wrapper');

    if (this.userRoleDialogWrapper) {
      this.userRoleDialog = document.querySelector('.user-role-dialog');
      this.userRoleDialog.addEventListener('submit', (e) => {
        e.preventDefault();
      });

      const userRoleButtons = [...document.querySelectorAll('button')];
      userRoleButtons.forEach((button) => {
        button.addEventListener('click', () => this.onClickUserRoleButton(button));
      });
    }
  }

  onClickUserRoleButton(button) {
    const { role } = button.dataset;
    const redirectUrl = this.removeTrailingSlash(button.dataset.url);
    const windowLocation = this.removeTrailingSlash(window.location.href);

    this.setCookie(role);

    if (redirectUrl !== windowLocation) {
      window.location = redirectUrl;
    } else {
      this.userRoleDialogWrapper.classList.remove('-show');
    }
  }


  setCookie(role) {
    const date = new Date();
    date.setFullYear(date.getUTCFullYear() + 1);
    const userRoleCookie = `user_role=${role};expires=${date.toGMTString()}; path=/`;
    document.cookie = userRoleCookie;
  }

  removeTrailingSlash(url) {
    return url.replace(/\/$/, '');
  }
}

domReady(() => {
  UserRole.init();
});
